export const FILE_BASE_NAME_MAX_LENGTH = 200
const UNSAFE_RUN = /[\\/:*?"<>|]+/g
const UNSAFE_RUN_BEFORE_SPACE = /[\\/:*?"<>|]+(?=\s)/g
const WHITESPACE_RUN = /\s+/g
const EDGE_PUNCTUATION = /^[.\s-]+|[.\s-]+$/g

export function splitFileName(name: string): { base: string; extension: string } {
  const dot = name.lastIndexOf('.')
  if (dot <= 0) return { base: name, extension: '' }
  return { base: name.slice(0, dot), extension: name.slice(dot) }
}

function isPrintable(character: string): boolean {
  const code = character.charCodeAt(0)
  return code > 0x1f && code !== 0x7f
}

export function cleanFileBaseName(input: string): string {
  const cleaned = [...input]
    .filter(isPrintable)
    .join('')
    .replace(UNSAFE_RUN_BEFORE_SPACE, ' -')
    .replace(UNSAFE_RUN, '-')
    .replace(WHITESPACE_RUN, ' ')
    .replace(EDGE_PUNCTUATION, '')
  return [...cleaned].slice(0, FILE_BASE_NAME_MAX_LENGTH).join('').replace(EDGE_PUNCTUATION, '')
}
